import React, { useState } from 'react'
import { Question as QuestionProps } from '../faq.props'
import { Copy, Collapse, Typography, IconArrowDown } from '../../Common'
import styled from 'styled-components'

export const Question = ({
  isDefaultOpened = false,
  question,
  answer,
}: QuestionProps) => {
  const [isOpened, setIsOpened] = useState(isDefaultOpened)

  const hide = () => setIsOpened(false)

  const show = () => setIsOpened(true)

  return (
    <Container>
      <Top isOpened={isOpened} onClick={isOpened ? hide : show}>
        <Title>{question}</Title>
        <IconArrowDown />
      </Top>
      <Collapse
        expanded={isOpened}
        transition="height 0.4s cubic-bezier(.4, 0, .2, 1)"
      >
        <Answer>
          <Copy html={answer} />
        </Answer>
      </Collapse>
    </Container>
  )
}

const Container = styled.article`
  border-top: 0.1rem solid ${({ theme }) => theme.palette.disabled};
`

const Top = styled.div.attrs({
  className: 'pt-4 pb-2',
})<{ isOpened?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  & svg {
    position: relative;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    top: ${(props) => (props.isOpened ? '0.5rem' : '0')};
    transform: rotate(${(props) => (props.isOpened ? '-180deg' : 0)});
  }
`

const Title = styled(Typography).attrs({
  as: 'h2',
  variant: 4,
})`
  font-weight: normal;
`

const Answer = styled.div``
